import { FC } from 'react';

import { Section, SidePanel, SidePanelContent } from '@dbt-labs/sourdough';

import { ResourcePanelTitle } from '@/components/ResourcePanel/ResourcePanelTitle';
import { ResourceWithColumns } from '@/hooks/appliedColumns';
import {
  ResourceByEnvironmentParams,
  useResourceByEnvironment,
} from '@/hooks/discovery/resource';
import { parseUniqueId } from '@/typings/parseUniqueId';
import { getAccess, getTrustSignals } from '@/util/dbt/resourceAppliedNode';
import { ColumnsView } from '../project/resource/details/components/Tabs/ColumnsView';

interface ColumnsSidePanelProps {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  selectedResourceParams: ResourceByEnvironmentParams;
}

export const ColumnsSidePanel: FC<ColumnsSidePanelProps> = ({
  isVisible,
  setIsVisible,
  selectedResourceParams,
}) => {
  const [resourceQuery] = useResourceByEnvironment(selectedResourceParams);
  const currentResource =
    resourceQuery.data?.environment?.applied?.resources?.edges?.[0]?.node;

  return (
    <SidePanel isOpen={isVisible} onClose={() => setIsVisible(false)}>
      {(onClose) => (
        <SidePanelContent
          title={
            <ResourcePanelTitle
              uniqueId={parseUniqueId(selectedResourceParams.uniqueId)}
              name={currentResource?.name || undefined}
              access={getAccess(currentResource)}
              trustSignals={getTrustSignals(currentResource)}
              className="px-4 pt-4"
            />
          }
          showBorder={false}
          onClose={onClose}
        >
          <Section>
            {currentResource && (
              <ColumnsView
                resource={currentResource as ResourceWithColumns}
                shouldShowLineage={false}
                className="px-4"
              />
            )}
          </Section>
        </SidePanelContent>
      )}
    </SidePanel>
  );
};
